
<style scoped lang='stylus'>
@import '../../assets/style/vars.styl'
.offline-order-flow-page
  background-color white
  height: 100vh;
  overflow: auto;
  display flex
  flex-direction column
  // 顶部step
  .flow-steps
    width 100%
    height 148px
    border-radius 0 0 26px 26px
    box-shadow 0px 4px 14px rgba(0,0,0,0.06)
    display flex
    background-color white
    z-index 10
    .through-line
      display flex
      position absolute
      top 42px
      height 2px
      left (100/6)%
      right (100/6)%
      background-color #CFE5FF
      .through-line-item
        flex 1
        height 100%
        background-color #CFE5FF
        &.actived
          background-color #3B95FF
    .step-item
      position relative
      flex 1 // 务必使用等分 满足画线等分
      flex-shrink 0
      display flex
      flex-direction column
      align-items center
      justify-content center
      height 100%
      .step-icon
        height 28px
        width 28px
        background-color #CFE5FF
        border-radius 28px
      .step-name
        font-size 24px
        line-height 34px
        margin-top 30px
        color #828393
      &.actived
        .step-icon
          background-color #3B95FF
        .step-name
          color #2A2A30
  // 详情
  .flow-detail
    flex 1
    flex-shrink 0
    overflow auto
    background-color rgba(231, 231, 240, 0.6)
  .detail-item
    width 100%
    padding 38px 0px 0 0
    background-color white
    box-sizing border-box
    background-color white
    &:not(:last-child)
      margin-bottom 20px
    .detail-header
      line-height 48px
      font-size 34px
      color #2A2A30
      font-weight 500
      font-weight 600
      padding-left 24px
    .flow-info
      padding 24px 24px 40px 24px
      border-bottom 1px solid rgba(231, 231, 240, 0.6)
      .flow-info-item
        width 100%
        display flex
        align-items center
        &:first-child
          margin-bottom 15px
        .info-text
          flex 1
          overflow hidden
          text-overflow ellipsis
          color #828393
          font-size 28px
          line-height 40px
        .info-icon
          width 30px
          height 30px
          margin-right 19px
          &.company
            bg-image('https://oss.turingsenseai.com/1610350924625285422.png')
          &.number
            bg-image('https://oss.turingsenseai.com/1610350909887321305.png')
    // flow-records
    .flow-records
      position relative
      padding 48px 24px
      box-sizing border-box
      border-bottom 2px solid rgba(29,29,29,0.1)
      .record-item
        position relative
        display flex
        overflow hidden
        &:last-child
          .icon::after
            height 0
        &:not(:last-child)
          padding-bottom 64px
        &.active
          .content, .content .content-2-main
            color #2A2A30
          .icon
            bg-image('https://oss.turingsenseai.com/1665643186667341516.png')
            &::after
              border-right 2px dashed #3B95FF
        &:last-child
          margin-bottom 0
        .date-time
          position relative
          top -3px
          width 80px
          display flex
          flex-direction column
          .date
            font-size 28px
            line-height 34px
            color #2A2A30
            margin-bottom 11px
            text-align right
          .time
            font-size 20px
            line-height 24px
            color #828393
            text-align right
        .icon
          width 22px
          height 22px
          margin 0 15px
          bg-image('https://oss.turingsenseai.com/1610349620776134467.png')
          position relative
          &::after
            content ''
            display inline-block
            position absolute
            top 22px
            left 11px
            height 400px // 这根线足够长吧
            width 0px
            border-right 2px solid #E6E6E9
            box-sizing content-box
        .content
          position relative
          top -3px
          flex 1
          white-space normal
          font-size 24px
          line-height 34px
          color #828393
          padding-right 40px
          .content-2-main
            font-size 28px !important
            margin-bottom 10px
          .content-2-text
            // color #828393 !important
            font-size 24px !important
          // 平台回收
          .recycle-content
            position relative
            color #2A2A30
            .count-down
              display flex
              align-items center
              justify-content space-between
              position absolute
              top 1px
              right 10px
              // width 150px
              font-size 28px
              .seconds-icon
                width 34px
                height 38px
                bg-image('https://oss.turingsenseai.com/1602233223282028463.png')
                // background-size 33px 33px
                margin-right 12px
              .simple-count-down
                width 150px
            .r-title
              font-weight 600
              font-size 26px
              margin-bottom 10px
            .r-sub-title
              font-size 24px
              color #828393
              margin-bottom 28px
            .r-btns .r-btn
              width 104px
              height 50px
              font-weight 300
              background-color #3B95FF
              color white
              border none
              font-size 28px
              margin-right 24px
              &:active
                opacity .9
              &.gray
                background-color transparent
                color #3B95FF
                border 1px solid #3B95FF
        .white-cover-line
          position absolute
          top 32px
          bottom 0px
          left 107px
          width 10px
          background-color white
</style>
<template>
  <div class="offline-order-flow-page">
    <!-- 顶部物流模块进度 -->
    <div v-if="flowDataHeader && flowDataHeader.length" class="flow-steps">
      <!-- <div class="through-line"></div> -->
      <div class="through-line">
        <!-- 第一段隐藏 -->
        <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
        <div v-if="!item.itemTitleHide"
          class="through-line-item"
          v-for="(item, index) in flowDataHeader"
          v-show="index > 0"
          :key="index"
          :class="[item.itemState ? 'actived' : '']"
        ></div>
      </div>
      <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
      <div :class="['step-item', item.itemState ? 'actived' : '']" v-for="(item, index) in flowDataHeader" :key="index" v-if="!item.itemTitleHide">
        <div class="step-icon"></div>
        <p class="step-name">{{item.itemTitle || '--'}}</p>
      </div>
    </div>
    <!-- 物流详情 -->
    <div class="flow-detail" v-if="flowData && flowData.length">
      <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
      <div class="detail-item" v-for="(item, index) in flowData" :key="index" v-if="item.hasDetail">
        <h3 class="detail-header">{{item.itemTitle}}</h3>
        <!-- flowType === 1 : 物流公司信息 -->
        <!-- flowType === 2 : 平台回收（无相关需要展示） -->
        <div class="flow-info" v-if="item.flowType == 1 && (item.expressCompany || item.expressNumber)">
          <div class="flow-info-item" v-show="item.expressCompany">
            <div class="info-icon company"></div>
            <div class="info-text">物流公司：{{item.expressCompany}}</div>
          </div>
          <div class="flow-info-item" v-show="item.expressNumber">
            <div class="info-icon number"></div>
            <div class="info-text">快递单号：{{item.expressNumber}}</div>
          </div>
        </div>
        <!-- 物流记录 -->
        <div class="flow-records" v-if="item.records && item.records.length">
          <!-- <div class="through-line"></div> -->
          <div :class="['record-item', index === 0 && rindex == 0 ? 'active' : '']" v-for="(record, rindex) in item.records" :key="rindex">
            <!-- <div v-if="rindex === item.records.length - 1" class="white-cover-line"></div> -->
            <div class="date-time">
              <span class="date">{{record.updateTime | formatDateTime('MM.DD')}}</span>
              <span class="time">{{record.updateTime | formatDateTime('HH:mm')}}</span>
            </div>
            <div class="icon"></div>
            <div class="content">
              <template v-if="record.isRecycle && record.recycleDetail && record.recycleDetail.seconds">
                <div class="recycle-content">
                  <div class="r-title">
                    确认平台回收报价
                  </div>
                  <!-- 倒计时 seconds -->
                  <div class="count-down">
                    <!-- 如果超时了 按照正常流转结构体展示 -->
                    <template v-if="record.recycleDetail.seconds" >
                      <div class="seconds-icon"></div>
                      <secondsCountDown :seconds="record.recycleDetail.seconds"></secondsCountDown>
                    </template>
                    <span v-else class="over-time">回收确认超时</span>
                  </div>
                  <div class="r-sub-title">
                    平台回收报价 ￥{{record.recycleDetail.price / 100}}
                  </div>
                  <div class="r-btns" v-if="record.recycleDetail.seconds">
                    <button class="r-btn gray" @click="recycleAcceptHandler(false)">拒绝</button>
                    <button class="r-btn" @click="recycleAcceptHandler(true)">接受</button>
                  </div>
                </div>
              </template>
              <!-- 带主次标题文案的 -->
              <template v-else-if="record.comment">
                <div v-if="record.comment" class="content-2-main">{{record.content}}</div>
                <div v-if="record.content" class="content-2-text">{{record.comment}}</div>
              </template>
              <!-- 不带主次标题文案的 -->
              <template v-else-if="!record.comment">
                <div v-if="record.content" class="content-text">{{record.content}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { userCheckProcess, recycleAccept } from '../../common/api/offline-identify'
import { getLocationQuery } from '../../common/utils'
import secondsCountDown from './count-down'
import { setTimeout } from 'timers';
// import testData from './test'
export default {
  name: '',
  components: {
    secondsCountDown
  },
  mixins: [],
  props: {
    // name: { type: Array, default: () => [] }
  },
  data: function () {
    return {
      flowDataHeader: [],
      flowData: []
    }
  },
  computed: {},
  created: function () {
    const querys = getLocationQuery() || {}
    const { orderNumber } = querys
    this.orderNumber = orderNumber
    this.getData(this.orderNumber)
  },
  mounted: function () {},
  // beforeDestroy: function() {},
  watch: {},
  methods: {
    async getData (orderNumber) {
      const res = await userCheckProcess({ orderNumber })
      // const res = testData
      if (res && res.errorCode === 0) {
        this.flowDataHeader = res.flowItems
        this.flowData = res.flowItems.filter(item => item.itemState).reverse()
        setTimeout(() => {
          try {
            // hack：由于业务乱原因 首个高亮流程阶段没有被命中 这里取到第一个元素 手动激活样式
            document.querySelectorAll('.detail-item:first-child .flow-records .record-item:first-child')[0].classList.add('active')
          } catch (e) {}
        }, 100)
      }
    },
    // 回收♻️
    async recycleAcceptHandler (isAccept) {
      const res = await recycleAccept({ orderNumber: this.orderNumber, isAccept })
      if (res && res.errorCode === 0) {
        isAccept && this.$$toast('您已同意平台商品回收报价，货款已打款至您的包小鉴钱包')
        setTimeout(() => {
          this.getData(this.orderNumber)
        }, 1400)
      }
    }
  },
  filters: {
    formatDateTime (value, format = 'MM-DD HH:mm') {
      return dayjs(value).format(format)
    }
  }
}
</script>
